<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-app-bar dark color="primary">
            <v-toolbar-title>{{ $t("auth.forgot.forgot_t") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-form ref="form">
              <v-text-field
                name="email"
                v-model="email"
                prepend-icon="person"
                :label="$t('auth.email')"
                v-validate="'required'"
                :error-messages="errors.collect('email')"
                type="text"
                autocomplete="off"
                v-if="type == 'email'"
              ></v-text-field>

              <PhoneInput
                class="required-field"
                v-validate="'required'"
                :label="$t('auth.mobile')"
                v-model="mobile"
                @input="
                  (formattedNumber, { number, country }) => {
                    mobile = (number && number.significant) || formattedNumber
                    mobile_code = country.dialCode || null
                  }
                "
                placeholder=""
                data-vv-name="mobile"
                :error-messages="errors.collect('mobile')"
                defaultCountry="NO"
                v-if="type == 'mobile'"
              ></PhoneInput>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>

            <router-link :to="'/auth/' + locale + '/login'" class="mr-2">
              <action-button
                type="default"
                :text="$t('global.back')"
                :icon_only_xs="false"
              />
            </router-link>

            <action-button
              @click="send"
              type="default"
              :text="$t('auth.forgot.send_request')"
              :icon_only_xs="false"
            />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="showEnterSMSCode"
      persistent
      max-width="400px"
      class="mt-0"
    >
      <v-card>
        <v-app-bar dark color="primary">
          {{ $t("auth.sms_code") }}
        </v-app-bar>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <p>
            {{
              $t("auth.enter_code_sms", {
                mobile: $formatPhoneNumber(mobile, mobile_code),
              })
            }}
          </p>
          <v-flex xs12>
            <v-text-field
              name="sms_code"
              v-model="sms_code"
              :label="$t('auth.enter_code')"
              autocomplete="off"
            ></v-text-field>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <action-button type="cancel" @click="closeSMSCodeDialog()" />
          <action-button
            type="default"
            color="info"
            :text="
              resend_status && resend_timer > 0
                ? `${$t('global.resend_in')} ${resend_timer}`
                : $t('global.resend')
            "
            icon="fas fa-sms"
            @click="resendSMSCode()"
            :disabled="Boolean(resend_status)"
          />
          <action-button type="validate" @click="validateSMSCode" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showSetPassword"
      persistent
      max-width="400px"
      class="mt-0"
    >
      <v-card>
        <v-app-bar dark color="primary">
          {{ $t("auth.set_password") }}
        </v-app-bar>
        <v-divider></v-divider>
        <v-card-text>
          <v-form data-vv-scope="setpasswordform">
            <v-flex xs12>
              <v-text-field
                data-vv-name="setpasswordform.new_password"
                prepend-icon="lock"
                v-model="new_password"
                class="required-field"
                v-validate="'required|password_strength'"
                :label="$t('auth.new_password')"
                :error-messages="errors.collect('setpasswordform.new_password')"
                type="password"
                ref="setpasswordform.new_password"
                :hint="$t('global.helptext_password')"
                persistent-hint
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                data-vv-name="setpasswordform.new_password_retype"
                prepend-icon="lock"
                v-model="new_password_retype"
                class="required-field"
                v-validate="
                  'required|confirmed:setpasswordform.new_password|password_strength'
                "
                :label="$t('auth.new_password_retype')"
                :error-messages="
                  errors.collect('setpasswordform.new_password_retype')
                "
                type="password"
                :hint="$t('global.helptext_password')"
                persistent-hint
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <action-button
            type="default"
            :text="$t('auth.update_password')"
            @click="setPassword"
            :icon_only_xs="false"
          />
          <action-button
            type="cancel"
            @click="cancelSetPassword"
            :icon_only_xs="false"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { ActionButton } from "@brakomp/ui"

import { PhoneInput } from "@brakomp/inputs"

export default {
  name: "Forgot",

  props: ["locale"],

  components: { ActionButton, PhoneInput },

  data() {
    return {
      email: null,
      mobile: null,
      mobile_code: null,
      type: null,

      resend_second: 15,
      resend_status: false,
      resend_timer: 0,

      showEnterSMSCode: false,
      sms_code: null,
      sms_uuid: null,

      showSetPassword: false,
      new_password: "",
      new_password_retype: "",
      setPasswordUserID: null,

      dictionary: {
        attributes: {
          email: this.$t("auth.email"),
          mobile: this.$t("auth.mobile"),
        },
      },
    }
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  created() {
    let vm = this
    let user = localStorage.getItem("__crrntUser")
    this.type = this.$route.query.type

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    if (user) {
      if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
        vm.$router.push(vm.BACKEND_URL + "/dashboard")
      } else {
        vm.$router.push(vm.BACKEND_URL + "/my")
      }
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid)
    },
  },

  methods: {
    send() {
      let vm = this

      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(valid => {
          console.log(this.type)
          if (valid) {
            if (this.type == "email") {
              axios
                .post(this.API_URL + "auth/forgotpassword/request", {
                  email: vm.email,
                })
                .then(res => {
                  var status = res.data.status

                  if (status == "sent") {
                    vm.$awn.success(
                      vm.$t("auth.forgot.forgot_success_m") + vm.email,
                    )
                    vm.$router.push("/auth/" + this.locale + "/login")
                  } else if (status == "unregistered") {
                    vm.$awn.alert(vm.email + vm.$t("auth.forgot.unregistered"))
                    vm.$router.push("/auth/" + this.locale + "/login")
                  }
                })
                .catch(err => console.log(err))
            }

            if (this.type == "mobile") {
              this.openSMSCodeDialog()
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    mobileLogin(id, token) {
      axios
        .post(this.API_URL + "auth/loginUser", {
          id: id,
          token: token,
          type: "mobile",
        })
        .then(res => {
          this.postLogin(res.data)
        })
        .catch(err => console.log(err))
    },
    postLogin(data) {
      let vm = this
      let token = data.access_token
      let user = data.user_data

      if (token && user && (user.status == 1 || user.status == 3)) {
        let status = user.status
        let locale = "no"

        this.$cookies.set(`${this.COOKIE_PREFIX}access_token`, token)
        vm.$setAuthorization(token)
        vm.$init(token, user)

        let localesetting = user.settings.find(i => i.key == "locale")
        if (localesetting && localesetting.value) {
          locale = localesetting.value
        }

        this.$updateSetting("fe_locale", locale)
        this.$updateSetting("locale", locale)
        this.$i18n.locale = locale

        if (status == 1) {
          // After login redirects
          if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
            vm.$router.push(vm.BACKEND_URL + "/dashboard")
          } else {
            vm.$router.push(vm.BACKEND_URL + "/my")
          }
        } else if (status == 3) {
          this.$router.push("/auth/" + locale + "/forcechangepassword")
        }
      } else {
        vm.$awn.alert(vm.$t("auth.login_error"))
      }
    },

    // SMS OTP
    openSMSCodeDialog() {
      axios
        .post(this.API_URL + "smsotp/generate", {
          type: "login-mobile",
          number: this.$formatPhoneNumber(this.mobile, this.mobile_code),
        })
        .then(res => {
          let status = res.data.status

          if (status == "ok") {
            this.showEnterSMSCode = true
            this.sms_uuid = res.data.uuid
          } else {
            let message =
              res.data.message || this.$t("auth.sms_otp_send_failed")
            this.$awn.alert(message)
          }
        })
        .catch(err => console.log(err))
    },
    validateSMSCode() {
      axios
        .post(this.API_URL + "smsotp/validate", {
          type: "login-mobile",
          uuid: this.sms_uuid,
          code: this.sms_code,
        })
        .then(res => {
          let status = res.data.status
          let type = res.data.type

          if (status == "ok") {
            this.closeSMSCodeDialog()

            if (type == "login-mobile") {
              var userid = res.data.param_userid
              var usertoken = res.data.param_usertoken
              this.openSetPassword(userid, usertoken)
            }
          } else {
            let message =
              res.data.message || this.$t("auth.sms_otp_incorrect_code")
            this.$awn.alert(message)
          }
        })
        .catch(err => console.log(err))
    },
    resendSMSCode() {
      let vm = this

      axios
        .post(this.API_URL + "smsotp/resend", {
          uuid: this.sms_uuid,
          type: "login-mobile",
          number: this.$formatPhoneNumber(this.mobile, this.mobile_code),
        })
        .then(res => {
          let status = res.data.status

          if (status == "ok") {
            this.sms_uuid = res.data.uuid
            this.resend_status = true
            this.resend_timer = this.resend_second

            let timer = setInterval(() => {
              vm.resend_timer = vm.resend_timer - 1
              console.log("Resend in " + vm.resend_timer)
              if (vm.resend_timer == 0) {
                vm.resend_status = false
                clearInterval(timer)
                console.log("Resend enabled")
              }
            }, 1000)
          } else {
            let message =
              res.data.message || this.$t("auth.sms_otp_send_failed")
            this.$awn.alert(message)
          }
        })
        .catch(err => console.log(err))
    },
    closeSMSCodeDialog() {
      this.showEnterSMSCode = false
      this.sms_code = null
      this.sms_uuid = null
    },

    // MOBILE SET PASSWORD
    setPassword() {
      let vm = this

      this.$validator
        .validateAll("setpasswordform")
        .then(valid => {
          if (valid) {
            axios
              .post(this.API_URL + "auth/password/update-only", {
                id: vm.setPasswordUserID,
                new_password: vm.new_password,
              })
              .then(() => {
                this.mobileLogin(vm.setPasswordUserID, vm.setPasswordUserToken)
              })
              .catch(err => console.log(err))
          }
        })
        .catch(() => {})
    },
    openSetPassword(user_id, token) {
      this.showSetPassword = true
      this.setPasswordUserID = user_id
      this.setPasswordUserToken = token
    },
    cancelSetPassword() {
      this.showSetPassword = false
      this.new_password = ""
      this.new_password_retype = ""
      this.setPasswordUserID = null
      this.setPasswordUserToken = null
    },
  },
}
</script>
